import APP_CONFIG from './app.config';

export const MP3_UNIVERSAL_SCORE = `${APP_CONFIG.soundsPath}universal-goal.mp3`;
export const MP3_UNIVERSAL_SET_END = `${APP_CONFIG.soundsPath}set-end.mp3`;
export const MP3_UNIVERSAL_MATCH_SET_END = `${APP_CONFIG.soundsPath}tennis-match-end.mp3`;
